module.exports = __webpack_public_path__ + "static/img/mobilegreen2.292f56a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilegreen2.png
// module id = CGwa
// module chunks = 1